namespace GeniuzPOS.ReportMasterData {
    export interface Report_1412Form {
    }

    export class Report_1412Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1412';
    }
}
